"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FitSign = void 0;
var api_wrapper_1 = require("@src/api/api-wrapper");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var iban_1 = require("@src/const/forms/iban");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var object_service_1 = require("@src/services/object-service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var voucher_code_const_1 = require("../fitfms/membership-completion/voucher-code.const");
var render_given_price_preview_1 = require("../fitfms/price-preview/render-given-price-preview");
var forms_const_1 = require("./const/forms.const");
var sign_api_service_1 = require("./services/sign-api.service");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var settings_service_1 = require("@src/services/settings.service");
var FitSign = /** @class */ (function () {
    function FitSign() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.signWasSuccess = false;
    }
    FitSign.prototype.renderAlreadyTransferred = function (minor) {
        return __awaiter(this, void 0, void 0, function () {
            var signedAt, success;
            return __generator(this, function (_a) {
                this.$container.html('');
                signedAt = minor.signedAt;
                success = (0, cash_dom_1.default)('<div>')
                    .text(translation_1.default.t('Thank you! The membership was successfully signed at ') +
                    (typeof signedAt === 'number' ? new Date(signedAt) : signedAt !== null && signedAt !== void 0 ? signedAt : new Date()).toISOString().split('T')[0] +
                    translation_1.default.t('. If something is unclear dont hesitate to contact us.'))
                    .css('width', '100%');
                this.$container.prepend(success);
                return [2 /*return*/];
            });
        });
    };
    FitSign.prototype.renderAlreadySigned = function (minor) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    FitSign.prototype.renderPricePreview = function (minor) {
        return __awaiter(this, void 0, void 0, function () {
            var provider, studioId, offering, renderPricePreview, successRow, res, successRow;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function (_u) {
                switch (_u.label) {
                    case 0:
                        this.persistContractDates(minor);
                        provider = minor.crmRequest.provider;
                        studioId = String(provider && 'studioId' in provider ? provider.studioId : minor.crmRequest.studioId);
                        return [4 /*yield*/, this.getOfferings(studioId, String(minor.crmRequest.contractData.rateBundleTermId))];
                    case 1:
                        offering = _u.sent();
                        if (!offering) return [3 /*break*/, 3];
                        renderPricePreview = new render_given_price_preview_1.RenderGivenPricePreview();
                        renderPricePreview.$container = this.$container.find('[data-module="price-preview"]');
                        if (renderPricePreview.$container.length === 0) {
                            renderPricePreview.$container = (0, cash_dom_1.default)('<div data-module="price-preview"></div>');
                        }
                        renderPricePreview.renderPrice({
                            studioName: minor.crmRequest.studioName,
                            term: offering.term,
                            offering: offering.offer,
                            paidModules: (_c = (_b = (_a = minor.crmRequest.contractData) === null || _a === void 0 ? void 0 : _a.optionalRateBundleTermModules) === null || _b === void 0 ? void 0 : _b.map(function (a) { return +a.id; })) !== null && _c !== void 0 ? _c : [],
                            freeModules: (_f = (_e = (_d = minor.crmRequest.contractData) === null || _d === void 0 ? void 0 : _d.selectedRateBundleModules) === null || _e === void 0 ? void 0 : _e.map(function (a) { return +a.id; })) !== null && _f !== void 0 ? _f : [],
                            startDate: (_g = minor.crmRequest.contractData) === null || _g === void 0 ? void 0 : _g.startDate,
                            preuseDate: (_h = minor.crmRequest.contractData) === null || _h === void 0 ? void 0 : _h.preuseDate,
                            preview: undefined,
                        });
                        if ((_l = (_k = (_j = minor === null || minor === void 0 ? void 0 : minor.crmRequest) === null || _j === void 0 ? void 0 : _j.contractData) === null || _k === void 0 ? void 0 : _k.notes) === null || _l === void 0 ? void 0 : _l.length) {
                            successRow = (0, generator_const_1._GetRow)({ html: translation_1.default.t('Special notes') + ': ' + ((_o = (_m = minor === null || minor === void 0 ? void 0 : minor.crmRequest) === null || _m === void 0 ? void 0 : _m.contractData) === null || _o === void 0 ? void 0 : _o.notes) }, 'transparent');
                            renderPricePreview === null || renderPricePreview === void 0 ? void 0 : renderPricePreview.appendPricingDetails(successRow);
                        }
                        if (!((_q = (_p = minor === null || minor === void 0 ? void 0 : minor.crmRequest) === null || _p === void 0 ? void 0 : _p.voucherCode) === null || _q === void 0 ? void 0 : _q.length)) return [3 /*break*/, 3];
                        localStorage.setItem(input_mapping_const_1._AllMappings.voucherCode.uid, (_r = minor === null || minor === void 0 ? void 0 : minor.crmRequest) === null || _r === void 0 ? void 0 : _r.voucherCode);
                        return [4 /*yield*/, (0, voucher_code_const_1._VouchercodeRequest)((_s = minor === null || minor === void 0 ? void 0 : minor.crmRequest) === null || _s === void 0 ? void 0 : _s.voucherCode, studioId)];
                    case 2:
                        res = _u.sent();
                        if ((_t = res.voucherSuccessMessage) === null || _t === void 0 ? void 0 : _t.length) {
                            successRow = (0, generator_const_1._GetRow)({ html: res.voucherSuccessMessage }, 'success');
                            if (renderPricePreview) {
                                renderPricePreview.preview = res;
                            }
                            renderPricePreview === null || renderPricePreview === void 0 ? void 0 : renderPricePreview.appendPricingDetails(successRow);
                        }
                        _u.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FitSign.prototype.renderToBeSigned = function (minor) {
        return __awaiter(this, void 0, void 0, function () {
            var $iban, paymentLabel, lockedHtml, $accountHolder;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                this.renderPricePreview(minor);
                console.log('hash', this.hash);
                if (minor.fitBuyData) {
                    $iban = this.$container.find("[data-get='".concat(forms_const_1._FitsignFormEditable.guardianIBAN.uid, "']"));
                    if ($iban.length) {
                        paymentLabel = (_a = minor.fitBuyData.paymentProvider) !== null && _a !== void 0 ? _a : 'Zahlungsmethode hinterlegt';
                        lockedHtml = "\n      <div\n        style=\"\n          display:flex;\n          align-items:center;\n          gap:8px;\n          padding:10px 12px;\n          border:1px solid var(--border-default, #eaeaea);\n          border-radius:8px;\n          font-family:inherit;\n          font-size:14px;\n          line-height:1.2;\n          margin-bottom: 1rem;\n        \"\n      >\n        <span\n          aria-hidden=\"true\"\n          style=\"\n            display:inline-flex;\n            width:18px;\n            height:18px;\n            align-items:center;\n            justify-content:center;\n            border-radius:999px;\n            font-size:12px;\n            line-height:1;\n            flex:0 0 auto;\n          \"\n        >\u2714</span>\n        <span style=\"font-weight:600;\">".concat(paymentLabel, "</span>\n      </div>\n    ");
                        $iban.replaceWith(lockedHtml);
                    }
                    $accountHolder = this.$container.find("[data-get='".concat(forms_const_1._FitsignFormEditable.guardianAccountHolder.uid, "']"));
                    if ($accountHolder.length) {
                        $accountHolder.remove();
                    }
                }
                else {
                    (0, input_output_helper_const_1._ValidateFields)(this.$container, { mappings: forms_const_1._FitsignFormEditable, generateFieldsIfNotExists: true, showErrors: false });
                }
                (0, input_output_helper_const_1._PrefillFields)(this.$container, {
                    mappings: forms_const_1._FitsignForm,
                    values: minor,
                });
                console.log('configurationUnderage', minor);
                this.$container.find('[data-action="submit"]').on('click', function (event) {
                    if (_this.signWasSuccess)
                        return;
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    _this.signDocument(minor);
                });
                return [2 /*return*/];
            });
        });
    };
    FitSign.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error, minor, ibanField, e_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.hash = (_a = this.getQueryParam('hash')) !== null && _a !== void 0 ? _a : '';
                        if (!((_b = this === null || this === void 0 ? void 0 : this.hash) === null || _b === void 0 ? void 0 : _b.length)) {
                            this.$container.html('');
                            error = (0, cash_dom_1.default)('<span style="color:red">').text('"Keinen validen Hash" bitte wenden Sie sich an unseren support.');
                            this.$container.append(error);
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 7]);
                        (0, generator_const_1._CreateLoadingScreen)(this.$container);
                        return [4 /*yield*/, (0, sign_api_service_1._FetchDocument)(this.hash)];
                    case 2:
                        minor = _c.sent();
                        (0, generator_const_1._DeleteLoadingScreen)(this.$container);
                        if (!minor.transferredToCRM) return [3 /*break*/, 3];
                        this.renderAlreadyTransferred(minor);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.renderToBeSigned(minor)];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5:
                        ibanField = (0, input_output_helper_const_1._GetFieldDomObj)(forms_const_1._FitsignFormEditable.guardianIBAN, this.$container);
                        if (ibanField.length) {
                            //TODO: LISTEN TO THE VALIDATION RIGHT NOW WE JUST DO IT BACKEND NOT
                            (0, iban_1._AddSmartValidationToIBAN)(ibanField);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _c.sent();
                        this.$container.html('');
                        return [2 /*return*/, this.errorMessage(e_1)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    FitSign.prototype.errorMessage = function (e) {
        var _a;
        (_a = (0, cash_dom_1.default)('#error-message')) === null || _a === void 0 ? void 0 : _a.remove();
        var error = (0, cash_dom_1.default)('<span style="color:red" id="error-message">').text(typeof e === 'string'
            ? e
            : 'Wir haben technische Schwiriegkeiten. Bitte wenden Sie sich an unseren Support falls das Problem bestehen bleibt.');
        this.$container.append(error);
        console.error(e);
    };
    FitSign.prototype.getQueryParam = function (paramName) {
        if (typeof window === 'undefined') {
            console.warn('window is not defined. This function should be run in a browser.');
            return null;
        }
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var paramValue = urlParams.get(paramName);
        return paramValue;
    };
    FitSign.prototype.signDocument = function (minor) {
        return __awaiter(this, void 0, void 0, function () {
            var underage, iban, res, domElem, err_1;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        (0, generator_const_1._CreateLoadingScreen)(this.$container);
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 4, , 5]);
                        underage = void 0;
                        if (minor.fitBuyData) {
                            underage = {
                                valid: true,
                                data: {
                                    crmRequest: {
                                        bankAccount: {
                                            iban: 'DE02120300000000202051',
                                            accountHolder: (_c = (_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.stripe) === null || _b === void 0 ? void 0 : _b.bankAccountHolder) !== null && _c !== void 0 ? _c : 'fitpay payments',
                                        },
                                    },
                                },
                                invalidFields: [],
                            };
                        }
                        else {
                            underage = (0, input_output_helper_const_1._ValidateFields)(this.$container, {
                                mappings: forms_const_1._FitsignFormEditable,
                                generateFieldsIfNotExists: true,
                                showErrors: true,
                            });
                        }
                        if (!underage.valid) return [3 /*break*/, 3];
                        iban = (_d = lodash_1.default.get(underage.data, 'crmRequest.bankAccount.iban')) !== null && _d !== void 0 ? _d : '';
                        if ((underage === null || underage === void 0 ? void 0 : underage.data) && (iban === null || iban === void 0 ? void 0 : iban.length)) {
                            lodash_1.default.set(underage.data, 'crmRequest.bankAccount.iban', iban.trim().replace(/\s/gi, ''));
                        }
                        return [4 /*yield*/, (0, sign_api_service_1._SignDocument)(this.hash, underage.data)];
                    case 2:
                        res = _k.sent();
                        this.signWasSuccess = true;
                        console.log(this.module.references);
                        domElem = (_f = (_e = this.module.references) === null || _e === void 0 ? void 0 : _e.submit) === null || _f === void 0 ? void 0 : _f.domElement;
                        if (domElem) {
                            (_g = domElem.get(0)) === null || _g === void 0 ? void 0 : _g.click();
                        }
                        else if (this.$container.find('[data-action="submit"]').length) {
                            (_h = this.$container.find('[data-action="submit"]').get(0)) === null || _h === void 0 ? void 0 : _h.click();
                        }
                        _k.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _k.sent();
                        (0, generator_const_1._DeleteLoadingScreen)(this.$container);
                        if (err_1.errorMessage === 'noValidIBAN' ||
                            err_1.errorMessage === 'noValidBankAccountHolder' ||
                            err_1.errorMessage === 'IBAN not valid') {
                            return [2 /*return*/, this.errorMessage(err_1.errorMessage)];
                        }
                        if ((_j = err_1 === null || err_1 === void 0 ? void 0 : err_1.displayMessage) === null || _j === void 0 ? void 0 : _j.length) {
                            //We could show a message here like hey we have received your signment but couldnt activate the account of your minor because x was wrong we contact you ASAP.
                            //The signment should be unproblematic but who knows
                            console.error('There is an error please try again later');
                        }
                        else {
                            this.$container.html('');
                            return [2 /*return*/, this.errorMessage(err_1)];
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        (0, generator_const_1._DeleteLoadingScreen)(this.$container);
                        return [2 /*return*/];
                }
            });
        });
    };
    FitSign.prototype.getOfferings = function (studioId, termId) {
        return __awaiter(this, void 0, void 0, function () {
            var offerings, existsForStudio, _i, offerings_1, offer, term;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper).getOfferings(studioId)];
                    case 1:
                        offerings = _a.sent();
                        if (offerings === null || offerings === void 0 ? void 0 : offerings.length) {
                            existsForStudio = false;
                            for (_i = 0, offerings_1 = offerings; _i < offerings_1.length; _i++) {
                                offer = offerings_1[_i];
                                term = offer.terms.find(function (a) { return String(a.id) === String(termId); });
                                if (term && offer) {
                                    (0, generator_const_1._HideErrorMessage)();
                                    existsForStudio = true;
                                    (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.rateBundleTermId, term.id.toString());
                                    console.log('found selected term', term, offer);
                                    return [2 /*return*/, { term: term, offer: offer }];
                                }
                            }
                            if (existsForStudio === false && termId) {
                                (0, generator_const_1._ShowErrorMessage)('Dieses Angebot existiert nicht für das Studio');
                            }
                        }
                        else {
                            (0, generator_const_1._ShowErrorMessage)('Keine Angebote für Studio gefunden');
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    FitSign.prototype.persistContractDates = function (minor) {
        var _a, _b, _c, _d;
        var contractData = minor.crmRequest.contractData;
        if (contractData === null || contractData === void 0 ? void 0 : contractData.startDate) {
            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.rateBundleStartDate, contractData.startDate);
        }
        if (contractData === null || contractData === void 0 ? void 0 : contractData.preuseDate) {
            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.preuseDate, contractData.preuseDate);
        }
        localStorage.setItem('optionalModules', JSON.stringify((_b = (_a = contractData === null || contractData === void 0 ? void 0 : contractData.optionalRateBundleTermModules) === null || _a === void 0 ? void 0 : _a.map(function (module) { return +module.id; })) !== null && _b !== void 0 ? _b : []));
        localStorage.setItem('selectableModules', JSON.stringify((_d = (_c = contractData === null || contractData === void 0 ? void 0 : contractData.selectedRateBundleModules) === null || _c === void 0 ? void 0 : _c.map(function (module) { return +module.id; })) !== null && _d !== void 0 ? _d : []));
    };
    return FitSign;
}());
exports.FitSign = FitSign;
